import {
  createComponentExtension,
  createPlugin,
} from '@backstage/core-plugin-api';

export const confidenceDevBarPlugin = createPlugin({
  id: 'confidence-devbar',
});

export const DevBar = confidenceDevBarPlugin.provide(
  createComponentExtension({
    name: 'DevBar',
    component: {
      lazy: () =>
        import(
          /* webpackChunkName: "confidence-devbar" */ './components/DevBar/DevBar'
        ).then(m => m.DevBar),
    },
  }),
);
